var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_3927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67695 6.24951C2.46781 6.24951 2.26972 6.16975 2.14278 6.03224L0.424888 4.17739C0.371776 4.12011 0.333 4.05483 0.310779 3.9853C0.288557 3.91576 0.283325 3.84333 0.295381 3.77214C0.307437 3.70095 0.336545 3.6324 0.381042 3.5704C0.425538 3.50841 0.48455 3.4542 0.554704 3.41085C0.624833 3.36733 0.704783 3.33554 0.789973 3.31732C0.875162 3.29909 0.963917 3.29478 1.05115 3.30464C1.13838 3.31449 1.22237 3.33832 1.29832 3.37475C1.37426 3.41118 1.44066 3.4595 1.49371 3.51694L2.62407 4.73648L5.46607 1.00713C5.56032 0.883997 5.71049 0.796439 5.88364 0.763663C6.05679 0.730886 6.23878 0.755567 6.38969 0.832292C6.70365 0.991807 6.80029 1.3297 6.60412 1.58665L3.24622 5.99099C3.1889 6.06651 3.10989 6.12946 3.01605 6.17437C2.92221 6.21929 2.81637 6.24481 2.70772 6.24873C2.69715 6.24951 2.68753 6.24951 2.67695 6.24951Z",
    fill: "#67C900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_3927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.82,
    height: 5.72,
    fill: "white",
    transform: "translate(0.0859375 0.639648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.73e22b511aedaec437e892c641183b1b.svg";
export { ForwardRef as ReactComponent };